export const ActionType = {
  GET_ALL_MAP_MARKS_START: "GET_ALL_MAP_MARKS_START",
  GET_ALL_MAP_MARKS_SUCCESS: "GET_ALL_MAP_MARKS_SUCCESS",
  GET_ALL_MAP_MARKS_ERRORS: "GET_ALL_MAP_MARKS_ERRORS",
  GET_MARK_PREVIEW_START: "GET_MARK_PREVIEW_START",
  GET_MARK_PREVIEW_SUCCESS: "GET_MARK_PREVIEW_SUCCESS",
  GET_MARK_PREVIEW_ERRORS: "GET_ALL_MAP_MARKS_ERRORS",
  SET_MARK_PREVIEW: "SET_MARK_PREVIEW"
};
